import { render, staticRenderFns } from "./FormSessionDialogWrap.vue?vue&type=template&id=24a0108a&scoped=true&"
import script from "./FormSessionDialogWrap.vue?vue&type=script&lang=ts&"
export * from "./FormSessionDialogWrap.vue?vue&type=script&lang=ts&"
import style0 from "./FormSessionDialogWrap.vue?vue&type=style&index=0&id=24a0108a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a0108a",
  null
  
)

export default component.exports